


















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import CardModel from '@/_models/CardModel'
import FloorModel from '@/_models/FloorModel'
import gmapsInit from '@/_services/gmap.service'
import MapAdjustBeacon from '@/_services/map.adjust.beacon.service'
import { Constant } from '@/_services/constant'
import _ from 'lodash'

let google: any = {}
let map: any = {}

@Component({
  components: {},
  computed: {},
})
export default class CardAdjust extends Vue {
  @Prop()
  singleCard!: any
  @Prop()
  // If edit or add new a card
  isSingle!: any
  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  selected: CardModel = new CardModel()
  isFormModalActive: boolean = false
  isSearchFloorActive: boolean = false
  searchQuery: string = ''
  searchQueryFloor: string = ''
  isNew: boolean = false
  selectedFilter: string = 'san_id'
  selectedFilterFloor: string = 'name'
  name: any = ''
  cardMarkers: any = []
  editingCards: any = []

  selectedFloor: FloorModel = new FloorModel()

  filedNameLUT: any = {
    _id: 'UUID',
    san_id: 'label.san_id',
    location_name: 'label.possition',
    lon: 'label.lon',
    lat: 'label.lat',
    floor_name: 'label.floor',
  }

  filedNameLUTFloor: any = {
    name: 'label.floor_name',
    building_name: 'label.building_name',
  }

  // computed
  get labelSanId(): string {
    return this.$t('label.san_id') as string
  }

  get cards(): CardModel[] {
    return this.$store.state.cards.all.items
  }

  get floors(): FloorModel[] {
    return this.$store.state.floors.all.items
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.cards.loading
  }

  get isLoadingFloor(): boolean {
    return this.$store.state.floors.loading
  }

  get filteredDataCard(): CardModel[] {
    // Edit/add single card
    if (this.isSingle) {
      return [this.selected]
    }
    const targetField: string = this.selectedFilter
    if (!this.cards) {
      return []
    }

    const cards = this.cards.filter((item: CardModel): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1 &&
        (item.floor_id === this.selectedFloor._id || item.floor_id === '')
      )
    })

    this.numofPage = Math.ceil(cards.length / this.perPage)

    return cards
  }

  get filteredDataFloor(): FloorModel[] {
    const targetField: string = this.selectedFilterFloor
    if (!this.floors) {
      return []
    }

    return this.floors.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQueryFloor.toLowerCase()) !== -1
      )
    })
  }

  get canDisplayMap(): boolean {
    return !_.isEmpty(this.selectedFloor._id)
  }

  get pinIconSelected(): string {
    return 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=.8|0|00d1b2|18|b|'
  }

  get setIconEditing(): string {
    return 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=.8|0|ff0000|18|b|'
  }

  get pinIcon(): string {
    return 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=.8|0|f9a834|18|b|'
  }

  @Watch('selected')
  async selectedCard() {
    for (const marker of this.cardMarkers) {
      if (marker._id === this.selected._id) {
        marker.setIcon(this.pinIconSelected)
      } else if (this.isEditingCard(marker._id)) {
        marker.setIcon(this.setIconEditing)
      } else {
        marker.setIcon(this.pinIcon)
      }
    }
  }

  @Watch('selectedFloor')
  async displayMap() {
    try {
      if (!this.canDisplayMap) {
        return
      }

      if (this.isSingle) {
        this.selected.floor_id = this.selectedFloor._id
        this.selected.floor_name = this.selectedFloor.name
      }

      const el = document.getElementById('cardMapAdjust')
      if (el === null) {
        return
      }
      const loadingComponent = this.$buefy.loading.open({})
      const center = this.getCenterMap()

      google = await gmapsInit()
      map = new google.maps.Map(el, {
        center,
        zoom: this.selectedFloor.floor_map_zoom,
        tilt: 0,
        clickableIcons: false,
        rotateControl: false,
        streetViewControl: false,
      })

      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(
          this.selectedFloor.floor_sw_lat,
          this.selectedFloor.floor_sw_lon
        ),
        new google.maps.LatLng(
          this.selectedFloor.floor_ne_lat,
          this.selectedFloor.floor_ne_lon
        )
      )

      const overlayOptions = {
        angle: this.selectedFloor.floor_angle,
        floorFile: this.selectedFloor.floor_file,
        floorOpacity: this.selectedFloor.floor_opacity,
        usePrettyPin: false,
      }

      MapAdjustBeacon(google, bounds, map, overlayOptions)

      // Attach cards to map
      for (const card of this.filteredDataCard) {
        this.createMarker(card)
      }

      loadingComponent.close()
    } catch (error) {
      console.error(error)
    }
  }

  // methods
  async handleSaveSetting(): Promise<any> {
    const data = new CardModel()
    if (this.isSingle) {
      data.lat = this.selected.lat
      data.lon = this.selected.lon
      data.floor_id = this.selected.floor_id
      data.floor_name = this.selected.floor_name
    } else if (this.filteredDataCard.length) {
      for (const card of this.filteredDataCard) {
        // Set floor_id for this record
        card.floor_id = this.selectedFloor._id
        await this.$store.dispatch('cards/updateOne', card)
      }
    }

    this.$emit('handleCardAdjustDone', data)
  }

  handleChangeFloor(item) {
    this.searchQueryFloor = item.name
    this.selectedFloor = item
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  convertFieldNameFloor(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUTFloor[value]) as string
  }

  createMarker(card: CardModel) {
    let position
    if (!this.isValidCoord(card.lat) || !this.isValidCoord(card.lon)) {
      position = this.getCenterMap()
      card.lat = position.lat
      card.lon = position.lng
    } else {
      position = new google.maps.LatLng(card.lat, card.lon)
    }
    const marker = new google.maps.Marker({
      position,
      map,
      animation: google.maps.Animation.DROP,
      draggable: true,
      title: card._id + ', ' + card.location_name,
      icon: this.isSingle ? this.pinIconSelected : this.pinIcon,
    })

    const self = this
    marker.addListener('click', () => {
      self.selected = card
    })

    marker._id = card._id

    google.maps.event.addListener(marker, 'dragend', (mk) => {
      this.selected = card

      const latLng = mk.latLng
      this.selected.lat = latLng.lat()
      this.selected.lon = latLng.lng()
      this.setEditingCard(this.selected)
    })

    this.cardMarkers.push(marker)
  }

  setEditingCard(card: CardModel): void {
    if (this.editingCards.indexOf(card._id) < 0) {
      this.editingCards.push(card._id)
    }
  }

  isEditingCard(cardId: string): boolean {
    return this.editingCards.indexOf(cardId) >= 0
  }

  isValidCoord(n) {
    if (typeof n === 'undefined' || n === 0 || n === '') {
      return false
    }

    return true
  }

  handleMovePinHere(): void {
    for (const marker of this.cardMarkers) {
      if (this.isSingle || marker._id === this.selected._id) {
        const center = this.getCenterMap()
        this.selected.lat = center.lat
        this.selected.lon = center.lng
        marker.setPosition(center)

        this.setEditingCard(this.selected)
      }
    }
  }

  getCenterMap(): { lng: number; lat: number } {
    return {
      lat:
        (this.selectedFloor.floor_sw_lat + this.selectedFloor.floor_ne_lat) / 2,
      lng:
        (this.selectedFloor.floor_sw_lon + this.selectedFloor.floor_ne_lon) / 2,
    }
  }

  // After page created
  created() {
    this.$store.dispatch('floors/getAll').then(() => {
      if (!this.filteredDataFloor || !this.filteredDataFloor.length) {
        return
      }

      if (!this.isSingle) {
        this.$store
          .dispatch('cards/getAll', { card_type: Constant.CARD_TYPE_STATIC })
          .then(() => {
            this.handleChangeFloor(this.filteredDataFloor[0])
          })
      } else {
        this.selected = Object.assign({}, this.singleCard)
        let isChangedFloor = false
        for (const floor of this.filteredDataFloor) {
          if (floor._id === this.selected.floor_id) {
            this.handleChangeFloor(floor)
            isChangedFloor = true
          }
        }

        if (!isChangedFloor) {
          this.handleChangeFloor(this.filteredDataFloor[0])
        }
      }
    })
  }
}
